import { UseI18nHook } from "@core/i18n/i18n";
import { UseNavigationHook } from "@core/routing/use-navigate";
import { Notification, PatientNotificationData } from "@domain/notification/notification";
import { RoutesPath, TabPatientDetails } from "@ui/navigation/routes";
import { computeDiffInDays, dateFromDateDto } from "@utils/date-utils";
import { formatName } from "@utils/string-utils";

export class PatientProgramEndingSoonNotification extends Notification {
	private get data() {
		return this.notification.data as {
			patient: PatientNotificationData;
			program: { name: string; endDate: string };
		};
	}

	format({ format, formatDateMed }: UseI18nHook): string {
		const endDate = dateFromDateDto(this.data.program.endDate);
		const diff = computeDiffInDays(this.notification.creationDate, endDate);

		return format("global.notifications.patientProgram.finishSoon", {
			patientName: formatName(this.data.patient),
			programName: this.data.program.name,
			date: formatDateMed(endDate),
			dayCount: diff,
		});
	}

	onClick(navigate: UseNavigationHook): void {
		navigate(RoutesPath.PatientDetails, {
			route: { patientId: this.data.patient.id },
			query: { active: TabPatientDetails.PROGRESS_TAB },
		});
	}
}
